import React, {useCallback, useEffect, useState} from 'react';
import AppApi from "../../api/AppApi";
import {GoogleMember} from "../../generated/account-client";

const client_id = '934272949812-qusnqn913vpc0cqvutcm0r6qaif43ec6.apps.googleusercontent.com';
const renderBtnProps = {theme: 'outline', size: 'large', width: '400'};

interface GoogleSignInProps {
  hidden?: boolean;
  onSuccess: (member: GoogleMember) => void;
  onError?: (e: any) => void;
  onStartLoading: () => void;
}

export default function GoogleAuthButton({onSuccess, onError, hidden, onStartLoading}: GoogleSignInProps) {
  const [error, setError] = useState();

  useEffect(() => {
    if (!error) return;

    onError?.(error);
  }, [error, onError]);

  const handleCredentialResponse = useCallback((response: any) => {
    if (!response) return;
    onStartLoading();
    AppApi.getGoogleMember(response.credential).then(resp => {
      onSuccess(resp.data);
    }).catch(e => {
      console.error(e);
      setError(e);
    });
  }, [onStartLoading, onSuccess]);

  useEffect(() => {
    window.google.accounts.id.initialize({client_id, callback: handleCredentialResponse});
    window.google.accounts.id.renderButton(document.getElementById('signInDiv'), renderBtnProps);
  }, [handleCredentialResponse]);

  return (
    <div id="signInDiv" style={hidden ? {opacity: "0", position: "absolute", marginLeft: '-15px'} : {}}></div>
  );
}
